import { render } from "./HeroiconsOutlineChevronDoubleDown.vue?vue&type=template&id=ebd017fa"
const script = {}

import exportComponent from "/Users/thuanluu/code/owlx/more9_venues/package/private/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChevronDoubleDown.vue"]])

export default __exports__